import { Drawer } from "@mui/material";
import React from "react";
import { ApprovalStatuses } from "../../constants/Status";
import { ApprovalModule, Modules } from "../../constants/Module";
import CreatorDetails from "../../pages/ChangeRequest/activities/creatorDetails";
import { ucFirst, ucFirstLetter } from "../../helpers/string_helper";
import CloseIcon from "@mui/icons-material/Close";
import UserProfile from "../casp/common/userProfile";
function ApprovalUserHistory({
  isOpen,
  handleClose,
  approvalLog,
  refresh,
  module,
  moduleDetail,
}) {
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={handleClose}
      className="projectListDrawer"
      PaperProps={{
        sx: { width: "580px" },
      }}
    >
      <div className="p-3">
        <h5>Approval History Log</h5>
        <CloseIcon className="crossIcon" onClick={handleClose} />
        {approvalLog && approvalLog.length > 0 ? (
          approvalLog.map((item, index) => (
            <div className="sidebar_borderbottom" key={index + 1}>
              <div className="d-flex py-3 sidebar_border">
                <UserProfile
                  user={item?.user}
                  avatarClassName="me-2 ml-2"
                  profileClassName="me-2 ml-2"
                />
                <div>
                  <strong> {ucFirst(Modules.APPROVAL_USER)} </strong>
                  was updated for{" "}
                  <strong>
                    {ucFirst(
                      module === Modules.CHANGE_REQUEST
                        ? Modules.CHANGE_REQUEST
                        : module
                    )}{" "}
                    {moduleDetail?.name ? `(${moduleDetail.name})` : ""}
                  </strong>
                  <CreatorDetails creator={item?.user} date={item?.createdAt} />
                </div>
              </div>
              <div>
                  <div className="d-flex py-3 sidebar_border">
                    <UserProfile
                      user={item?.user}
                      avatarClassName="me-2 ml-2"
                      profileClassName="me-2 ml-2"
                    />
                    <div className="d-flex align-items-center change_status">
                      {item?.status === ApprovalStatuses.REJECTED && (
                        <div className="d-flex align-items-center change_status">
                          <span>
                            <strong>
                              {ucFirst(
                                module === Modules.CHANGE_REQUEST
                                  ? Modules.CHANGE_REQUEST
                                  : module
                              )}{" "}
                              {moduleDetail.name
                                ? `(${moduleDetail.name})`
                                : ""}
                            </strong>{" "}
                            is rejected by{" "}
                            <strong>
                              {item?.user.name} [{item?.user?.uniqueUserId}]
                            </strong>
                          </span>
                        </div>
                      )}
                      {item?.status === ApprovalStatuses.APPROVED && (
                        <div className="d-flex align-items-center change_status">
                          <span>
                            <strong>
                              {ucFirst(
                                module === "changeRequest"
                                  ? Modules.CHANGE_REQUEST
                                  : module
                              )}{" "}
                              {moduleDetail.name
                                ? `(${moduleDetail.name})`
                                : ""}
                            </strong>{" "}
                            is approved by{" "}
                            <strong>
                              {item?.user.name} [{item?.user?.uniqueUserId}]
                            </strong>
                          </span>
                        </div>
                      )}
                      {item?.status === ApprovalStatuses.PENDING && (
                        <div className="d-flex align-items-center change_status">
                          <span>
                            <strong>
                              {ucFirst(
                                module === "changeRequest"
                                  ? Modules.CHANGE_REQUEST
                                  : module
                              )}{" "}
                              {moduleDetail.name
                                ? `(${moduleDetail.name})`
                                : ""}
                            </strong>{" "}
                            is sent for approval by{" "}
                            <strong>
                              {item?.user?.name} [{item?.user?.uniqueUserId}]
                            </strong>
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
              </div>
              </div>
          ))
        ) : (
          <div className="mx-2">
            <span>No approval history available.</span>
          </div>
        )}
      </div>
    </Drawer>
  );
}
export default ApprovalUserHistory;